import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I'm a Final Year BTech CSE student passionate about turning
              innovative ideas into functional, scalable applications. Currently
              honing my skills through hands-on projects while preparing to
              launch my software engineering career.
              <br />
              <br />
              I’m proficient in
              <i>
                <b className="purple">
                  {" "}
                  JavaScript, React.js, Node.js and actively learning C++
                  alongside data visualization with Tableau and beginner-level
                  data analytics.
                </b>
              </i>
              — bridging frontend interfaces with robust backend systems and
              data insights.
              <br />
              <br />
              My key areas of interest include building
              <i>
                <b className="purple">
                  {" "}
                  Web Applications with React.js & Next.js, data visualization
                  dashboards using Tableau, exploring API integrations,{" "}
                </b>
              </i>
              and creating responsive user experiences that solve real-world problems.
              <br />
              <br />
              Whenever possible, I love building projects with
              <b className="purple"> Node.js, React.js </b> and modern frameworks like{" "}
              <i>
                <b className="purple">Next.js</b> and{" "}
                <b className="purple">Tableau</b> for impactful data-driven solutions!
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
